import { Check } from "lucide-react";
import { talentBgImage } from "assets/website";
import { SystemBadges, openSelarStore } from "../shared";

const guarantees = [
  "Functional Google Sheets with clean progress scripts.",
  "Video brief integration guides.",
];

const ExecutionToolkit = () => {
  return (
    <div data-aos="fade-up" className="mt-12 md:mt-16">
      <h3 className="text-center text-xl md:text-2xl font-display font-normal text-[#475467] mb-6">
        The Complete Operating System
      </h3>

      {/* Card */}
      <div className="relative overflow-hidden rounded-[24px] border-2 border-[#F2A25B] bg-[#FDF6EF] px-6 pt-16 pb-10 sm:py-12 md:px-10 md:py-16 shadow-[0px_4px_4px_0px_#F2A25B0D]">
        {/* Background image */}
        <img
          src={talentBgImage}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute max-w-none select-none"
          style={{
            width: "1258.71px",
            height: "834.37px",
            top: "-370px",
            left: "-215px",
            opacity: 0.05,
            transform: "rotate(-20.86deg)",
          }}
        />

        {/* Most Purchased ribbon */}
        <div
          className="absolute top-0 right-6 md:right-10 flex w-[60px] sm:w-[72px] h-[55px] sm:h-[70px] items-start justify-center bg-[#2469E1] pt-2 text-center text-[9.5px] sm:text-[10px] font-medium leading-tight text-white"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 50% 80%, 0 100%)" }}
        >
          Most
          <br />
          Purchased
        </div>

        <div className="relative mx-auto flex max-w-[760px] flex-col items-center text-center">
          <h2 className="text-2xl sm:text-3xl md:text-[40px] lg:text-[52px] font-display font-semibold text-[#1D2939] leading-[1.1] tracking-[-0.5px] mb-5">
            One System. Everything Your Team Needs.
          </h2>

          <SystemBadges className="mb-6" />

          <p className="max-w-[620px] text-base md:text-xl text-[#667085] mb-8">
            Equip your team with the proven three interconnected systems for
            planning, ownership, execution, and performance management.
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <button
              onClick={openSelarStore}
              className="w-full sm:w-auto px-8 sm:py-4 py-3.5 bg-[#012169] hover:bg-[#011550] text-white text-base font-semibold rounded-[10px] transition-all duration-200 shadow-[0px_4px_8px_0px_#01216940]"
            >
              Get the Complete Suite
            </button>
          </div>

          {/* Guarantees */}
          <div className="sm:mt-8 mt-16 flex flex-col sm:flex-row sm:items-center justify-center gap-3 sm:gap-8">
            {guarantees.map((item) => (
              <div key={item} className="flex items-start text-left gap-2 text-sm text-[#475467]">
                <Check className="w-4 h-4 text-[#64CB5D] shrink-0 mt-1" strokeWidth={3} />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { ExecutionToolkit };
